/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type CursorPaginationResponseDtoSbtPaginationResponseDto,
  type ErrorResponseDto,
  type OffsetPaginationResponseDtoSbtPaginationResponseDto,
  type SbtApplyRequestDto,
  type SbtIssueStatisticsResponseDto,
  type SbtPresentRequestDto,
  type SbtProvideRequestDto,
  type SbtResponseDto,
  type SuccessCountResponseDto,
  type SuccessIdResponseDto,
} from '../dto/data-contracts';

export class Sbt<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 배지 부여
   *
   * @tags SBT
   * @name ProvideSbt
   * @summary 배지 부여
   * @request POST:/v1/admin/sbts
   * @secure
   */
  provideSbt = (data: SbtProvideRequestDto, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/admin/sbts`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 배지 선물
   *
   * @tags SBT
   * @name PresentSbt
   * @summary 배지 선물
   * @request POST:/v1/admin/sbts/present
   * @secure
   */
  presentSbt = (data: SbtPresentRequestDto, params: RequestParams = {}) =>
    this.http.request<SuccessCountResponseDto, ErrorResponseDto>({
      path: `/v1/admin/sbts/present`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 특정 유저의 배지 만료시키기
   *
   * @tags SBT
   * @name ExpireSbt
   * @summary 유저 배지 만료시키기
   * @request PATCH:/v1/admin/sbts/{sbtId}
   * @secure
   */
  expireSbt = (sbtId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponseDto>({
      path: `/v1/admin/sbts/${sbtId}`,
      method: 'PATCH',
      secure: true,
      ...params,
    });
  /**
   * @description 자신이 만든 템플릿을 발급 받은 유저 목록 조회
   *
   * @tags SBT
   * @name GetAllSbtForIssuer
   * @summary 템플릿 발급 유저 목록
   * @request GET:/v1/admin/users/{userId}/issue-sbts
   * @secure
   */
  getAllSbtForIssuer = (
    userId: string,
    query: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 만료 여부 */
      sbtStatusType: 'ALL' | 'ISSUED' | 'EXPIRED';
      /** 검색어 */
      search?: string;
      /** 검색 대상 */
      searchType?: 'USER' | 'BADGE';
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoSbtPaginationResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/admin/users/${userId}/issue-sbts`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 내 템플릿으로 발급 받은 배지 통계
   *
   * @tags SBT
   * @name GetSbtsStatistics
   * @summary 배지 발급 통계
   * @request GET:/v1/admin/users/{userId}/sbt-statistics
   * @secure
   */
  getSbtsStatistics = (
    userId: string,
    query: {
      duration: 'DAY' | 'MONTH' | 'YEAR';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SbtIssueStatisticsResponseDto, ErrorResponseDto>({
      path: `/v1/admin/users/${userId}/sbt-statistics`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 특정 유저가 보유한 배지 목록
   *
   * @tags SBT
   * @name GetAllSbtForTemplateOwner
   * @summary 보유 배지 목록 (오프셋)
   * @request GET:/v1/admin/users/{userId}/sbts
   */
  getAllSbtForTemplateOwner = (
    userId: string,
    query: {
      creatorId?: string;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoSbtPaginationResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/admin/users/${userId}/sbts`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 배지 발급 신청
   *
   * @tags SBT
   * @name ApplySbt
   * @summary 배지 발급 신청
   * @request POST:/v1/sbt-actions
   * @secure
   */
  applySbt = (data: SbtApplyRequestDto, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/sbt-actions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 배지 ID로 조회
   *
   * @tags SBT
   * @name GetSbtById
   * @summary 배지 조회
   * @request GET:/v1/sbts/{sbtId}
   */
  getSbtById = (sbtId: string, params: RequestParams = {}) =>
    this.http.request<SbtResponseDto, ErrorResponseDto>({
      path: `/v1/sbts/${sbtId}`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 특정 유저가 보유한 배지 목록
   *
   * @tags SBT
   * @name GetAllSbt
   * @summary 보유 배지 목록 (커서)
   * @request GET:/v1/users/{userId}/sbts
   */
  getAllSbt = (
    userId: string,
    query: {
      creatorId?: string;
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoSbtPaginationResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/sbts`,
      method: 'GET',
      query: query,
      ...params,
    });
}
